import React from 'react';
import { AgGridReact, AgGridReactProps } from 'ag-grid-react';
import { RowClassParams, RowStyle } from 'ag-grid-community';

type PaginationType = {
    currentPageNo: number;
    startPageNo: number;
    endPageNo: number;
    firstPageNo: number;
    prevPageNo: number;
    nextPageNo: number;
    finalPageNo: number;
};

export type AgGridTableProps<T extends Record<string, any>> =
    AgGridReactProps & {
        selectedRow?: T;
        selectedKey?: keyof T;
        selectedRowStyle?: RowStyle;

        pagination?: PaginationType;
        onPageChange?: (page: number) => void;
    };

function AgGridTable<T extends { id?: number | string }>(
    props: AgGridTableProps<T>
) {
    const {
        selectedRow,
        selectedKey = 'id',
        selectedRowStyle = { backgroundColor: 'rgb(255, 245, 220)' },
        getRowStyle,
        pagination,
        onPageChange,
        ...gridProps
    } = props;

    const mergedGetRowStyle = (params: RowClassParams): RowStyle | undefined => {
        if (
            selectedRow &&
            params.data &&
            params.data[selectedKey] === selectedRow[selectedKey]
        ) {
            return selectedRowStyle;
        }

        return getRowStyle?.(params);
    };

    return (
        <>
            <AgGridReact
                {...gridProps}
                getRowStyle={mergedGetRowStyle}
            />

            {pagination && onPageChange && (
                <div className="pagination block" style={{ paddingBottom: '0px' }}>
                    <ul className="paging">
                        <li onClick={() => onPageChange(pagination.firstPageNo)}>
                            {'<<'}
                        </li>

                        <li
                            className={
                                pagination.currentPageNo === pagination.prevPageNo
                                    ? 'disabled'
                                    : ''
                            }
                            onClick={() => onPageChange(pagination.prevPageNo)}
                        >
                            {'<'}
                        </li>

                        {Array.from(
                            {
                                length:
                                    pagination.endPageNo -
                                    pagination.startPageNo +
                                    1,
                            },
                            (_, i) => pagination.startPageNo + i
                        ).map((page) => (
                            <li
                                key={page}
                                className={
                                    pagination.currentPageNo === page
                                        ? 'select'
                                        : ''
                                }
                                onClick={() => onPageChange(page)}
                            >
                                {page}
                            </li>
                        ))}

                        <li
                            className={
                                pagination.currentPageNo === pagination.nextPageNo
                                    ? 'disabled'
                                    : ''
                            }
                            onClick={() => onPageChange(pagination.nextPageNo)}
                        >
                            {'>'}
                        </li>

                        <li onClick={() => onPageChange(pagination.finalPageNo)}>
                            {'>>'}
                        </li>
                    </ul>
                </div>
            )}
        </>
    );
}

export default AgGridTable;
